/**
 * Display formatting for catalog samples, matching what the Sounds plugin's
 * rows show so a sample reads the same in Labs as it does in the browser it
 * came from.
 */

/** `c#` + `minor` → `C#m`; `f` + `major` → `F`; no key → `--`. */
export const formatSampleKey = (key: string, chordType: string): string => {
    if (key === "") {
        return "--";
    }
    const root = key.charAt(0).toUpperCase() + key.slice(1);
    return chordType.toLowerCase() === "minor" ? `${root}m` : root;
};

/** `0` → `--`; otherwise the whole number of beats per minute. */
export const formatSampleBpm = (bpm: number): string => (bpm > 0 ? String(Math.round(bpm)) : "--");

/**
 * Short sounds get a decimal (`0.4s`, `3.2s`) because a one-shot's whole
 * story is under a second; from ten seconds up, `m:ss` like a track.
 */
export const formatSampleDuration = (duration_ms: number): string => {
    if (duration_ms <= 0) {
        return "--";
    }
    const seconds = duration_ms / 1000;
    if (seconds < 10) {
        return `${seconds.toFixed(1)}s`;
    }
    const whole = Math.round(seconds);
    const minutes = Math.floor(whole / 60);
    const remainder = whole % 60;
    return `${minutes}:${remainder.toString().padStart(2, "0")}`;
};
